var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo",attrs:{"src":require("../assets/images/header/kryptos-logo.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }